<template>
  <el-container class="general-layout">
    <el-header height="32" v-if="$slots.header">
      <slot name="header"></slot>
    </el-header>
    <el-main>
      <slot></slot>
    </el-main>
    <el-footer height="32" v-if="$slots.footer">
      <slot name="footer"></slot>
    </el-footer>
  </el-container>
</template>
<script>
export default {
  name: "general-layout",
  beforeMount() {
    this.setTableProps();
  },
  beforeUpdate() {
    this.setTableProps();
  },
  methods: {
    setTableProps() {
      for (let node of this.$slots.default) {
        let options = node.componentOptions;
        if (options?.tag === "el-table") {
          options.propsData = {
            border: true,
            height: "100%",
            tooltipEffect: "dark",
            ...options.propsData
          };
        }
      }
    }
  },
  mounted() {
    if (this.$el.parentElement === document.body) {
      document.body.classList.add("general-layout-flex-body");
    }
  }
};
</script>
<style>
.general-layout-flex-body {
  display: flex;
}
</style>
<style lang="less" scoped>
.el-container {
  flex-grow: 1;
  flex-direction: column;
  padding: 8px 12px 12px;
  box-sizing: border-box;
}
.el-header {
  padding: 0 0 8px;
}
.el-main {
  flex-grow: 1;
  padding: 0;
}
.el-footer {
  padding: 8px 0 0;
}
.el-main::v-deep .el-table {
  height: 100%;
  width: 100%;
  .cell {
    padding-top: 5px;
    padding-bottom: 5px;
    .el-button--text {
      padding: 0;
    }
  }
  td,
  th {
    height: 34px;
    padding: 0;
  }
}
.el-footer::v-deep .el-pagination {
  padding: 0;
  text-align: right;
}
</style>
